export var RichLanguageFormat;
(function (RichLanguageFormat) {
    RichLanguageFormat["TEXT"] = "text";
    RichLanguageFormat["JSON"] = "json";
})(RichLanguageFormat || (RichLanguageFormat = {}));
